import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Button,
  Menu,
  MenuButton,
  MenuList,
} from '@chakra-ui/react';
import { SharedDisclosureProps } from '@texas/components/shared/types';
import { useTranslation } from 'react-i18next';
import { SamplesTable } from './SamplesTable';
import { SampleLifecycleGroup } from '@texas/components/shared/samples/types';
import { Icons } from '@texas/components/shared/Icons';
import { SamplesWidgetContext } from './SamplesWidget';
import { PortalRefProvider, usePortalRef } from '@texas/hooks/usePortalRef';
import { useActiveContext } from '@texas/hooks/useActiveContext';

export interface SamplesOverviewModalProps {
  groupEnum: SampleLifecycleGroup;
  header: string;
}

interface Props extends SharedDisclosureProps, SamplesOverviewModalProps {}

export function SamplesOverviewModal({
  groupEnum,
  header,
  isOpen,
  onClose,
}: Props) {
  const { t } = useTranslation();
  const portalRef = usePortalRef();
  const samplesContext = useActiveContext(SamplesWidgetContext);

  return (
    <PortalRefProvider value={portalRef}>
      <Modal
        size="6xl"
        isOpen={isOpen}
        onClose={() => {
          samplesContext.useMultiSelect.setSelectedRows({});
          onClose();
        }}
      >
        <ModalOverlay />
        <ModalContent maxW="1400px">
          <ModalHeader>{header}</ModalHeader>
          <ModalCloseButton />
          <ModalBody {...portalRef.bindRef}>
            <Flex justify="flex-end" mb={1}>
              <Menu isLazy={true}>
                <MenuButton
                  as={Button}
                  aria-label={t('general.actions')}
                  rightIcon={<Icons.ChevronDown />}
                  disabled={
                    Object.keys(
                      samplesContext.useMultiSelect.selectedRows,
                    ).filter(
                      (x) => samplesContext.useMultiSelect.selectedRows[x],
                    ).length === 0
                  }
                >
                  {t('general.actions')}
                </MenuButton>
                <MenuList>{samplesContext.useMultiSelect.menuItems}</MenuList>
              </Menu>
            </Flex>
            <SamplesTable groupEnum={groupEnum} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </PortalRefProvider>
  );
}
